import { render, staticRenderFns } from "./ReportIcon.vue?vue&type=template&id=60ff3ecd&scoped=true"
import script from "./ReportIcon.vue?vue&type=script&lang=js"
export * from "./ReportIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff3ecd",
  null
  
)

export default component.exports